import { ClientSideComponent } from '@crehana/web';
import { useMediaQuery } from '@crehana/react-hooks';

import WhyCrehanaMobile from './Mobile/';
import WhyCrehanaDesktop from './Desktop/';

const WhyCrehana = () => {
  const { matches: isMd } = useMediaQuery('md');
  if (isMd) {
    return <WhyCrehanaDesktop />;
  } else {
    return <WhyCrehanaMobile />;
  }
};

export default function WhyCrehnaClientSide() {
  return (
    <ClientSideComponent>
      <WhyCrehana />
    </ClientSideComponent>
  );
}
